import { useTranslation } from "react-i18next";
import { AppStore } from "../../features/app-stores/storeLinks";
import ShareLinkBlock from "../members/ShareLinkBlock";
import StoreBadge from "./StoreBadge";

interface AppStoreBlocksProps {
  stores: readonly AppStore[];
  showQr: boolean;
  /** Side by side from the small breakpoint, with smaller QR codes — for a section inside another dialog. */
  compact?: boolean;
  /** Keeps the blocks' test ids unique when two dialogs could list the same store. */
  idPrefix?: string;
}

/** One block per store: its name, a QR code to scan from a phone, the official badge and Copy. */
const AppStoreBlocks = ({ stores, showQr, compact = false, idPrefix = "" }: AppStoreBlocksProps) => {
  const { t } = useTranslation();
  const layout = compact ? "grid grid-cols-1 gap-x-4 sm:grid-cols-2" : "divide-y divide-grey-90 dark:divide-grey-30";

  return (
    <div className={layout}>
      {stores.map((store) => (
        <ShareLinkBlock
          key={store.id}
          id={`${idPrefix}${store.id}`}
          label={t(store.nameKey)}
          url={store.url}
          showQr={showQr}
          qrAlt={t("getTheApp.qrAlt", { store: t(store.nameKey) })}
          badge={<StoreBadge store={store} />}
          compact={compact}
        />
      ))}
    </div>
  );
};

export default AppStoreBlocks;
